<!-- Issue 54 - Extraction number of calls by "Code Panne" -->
<div class="card-header" id="panneCodeHeader">
    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
        data-target="#panneCodeCollapse" aria-expanded="true" aria-controls="panneCodeCollapse">
        Nombre d'occurrences par code panne
    </button>
</div>

<div id="panneCodeCollapse" class="panel-collapse collapse" aria-labelledby="panneCodeHeader"
    data-parent="#accordionExtraction">
    <div class="card-body row">
        <form [formGroup]="panneCodesForm" (ngSubmit)="onSubmitCodePanne()" class="wrapper shadowed">
            <h4>Nombre d'occurrences par code panne</h4>
            <br>
            <div class="paragraphe">
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerstartDatePanne" placeholder="Date de début"
                        formControlName="startDateCodePanne">
                    <mat-datepicker-toggle matSuffix [for]="pickerstartDatePanne"></mat-datepicker-toggle>
                    <mat-datepicker #pickerstartDatePanne startView="month"></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerendDatePanne" placeholder="Date de fin"
                        formControlName="endDateCodePanne">
                    <mat-datepicker-toggle matSuffix [for]="pickerendDatePanne"></mat-datepicker-toggle>
                    <mat-datepicker #pickerendDatePanne startView="month"></mat-datepicker>
                </mat-form-field>

            </div>

            <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>

        </form>
        <br><br>

        <app-gmao-spinner *ngIf="isLoading"></app-gmao-spinner>


        <ng-container *ngIf="nbCodePanne">
            <div class="wrapper shadowed">

                <br />

                <h4>Résultats</h4>

                <app-export-button [data]="getData()"></app-export-button>

                <br />
                <span><b>Du : {{getNiceDate(startCP)}} au {{getNiceDate(endCP)}}</b></span>
                <mat-table [dataSource]="nbCodePanne">
                    <ng-container matColumnDef="code">
                        <mat-header-cell *matHeaderCellDef> Code </mat-header-cell>
                        <mat-cell *matCellDef="let rownb"> {{rownb.code}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nom">
                        <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
                        <mat-cell *matCellDef="let rownb"> {{rownb.nom}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nb">
                        <mat-header-cell *matHeaderCellDef> Nombre </mat-header-cell>
                        <mat-cell *matCellDef="let rownb"> {{rownb.nb}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumnNbCodePanne"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: ['code','nom', 'nb'] ;"></mat-row>
                </mat-table>

            </div>
        </ng-container>
        <br />
    </div>
</div>